export class UserSocket {
    public name: string;
    public login: string;
    public id: string;

    constructor( name: string, login: string, id: string ) {
        this.name = name;
        this.login = login;
        this.id = id;
    }
}
